var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }